export const config = {
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT as string,
  BACKEND_URL: import.meta.env.VITE_BACKEND_URL as string,
  LEAD_BACKEND_URL: import.meta.env.VITE_LEAD_BACKEND_URL as string,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN as string,
  FALLBACK_SUBDOMAIN: import.meta.env.VITE_FALLBACK_SUBDOMAIN as
    | string
    | undefined,
};
